import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Link } from 'react-router-dom'
import './catalogo.css'

class CatalogoItem extends React.Component {

    render() {
        return (
            <Link to={`/Catalogo/catalogoEdicion/${this.props.catalogo.idCatalogo}`}>
                <div className='itemContainer'>
                    {this.props.catalogo.imagenCatalogo !== undefined ? 
                        <React.Fragment>
                            <img  src={`data:image/ief;base64,${this.props.catalogo.imagenCatalogo}`} />
                            {this.props.catalogo.mostrarNombreCatalogo && <div className= 'nombreItemImage'>{this.props.catalogo.nombre}</div>}
                        </React.Fragment>    
                        :
                        <div>
                            <CircularProgress />
                            <div className='nombreItem'>{this.props.catalogo.nombre}</div>
                        </div>
                    }
                </div>
            </Link>
        )
    }
}

CatalogoItem.propTypes = {
    catalogo: PropTypes.object.isRequired,
    
}

CatalogoItem.defaultProps = {
    catalogo: []
}

export default CatalogoItem